import httpStore from "@/api/httpStore.js";

export function getAllInfoautoSellers() {
  return httpStore
    .get(`/sellers/all`)
    .then(res => ({ data: res.data || [], error: false }))
    .catch(() => ({ data: [], error: true }));
}

export function updateInfoautoSeller(id, payload) {
  return httpStore
    .put(`/sellers/update/${id}`, { seller: payload })
    .then(res => res.data);
}

export function getInfoautoSellersByEmail(email) {
  return httpStore
    .get(`/sellers/by_email`, { params: { email } })
    .then(res => ({ data: res.data || [], error: false }))
    .catch(() => ({ data: [], error: true }));
}
